import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    selectedItemsIds: [],
    expandedItemsIds: [],
    collapsedItemsIds: [],
    filteredItemsIds: [],
    updateQueue: [],
    filterOptions: 'showAllItems',
    isCalculatingOrder: false,
    selectedOrderItemDrawingId: null,
    openDrawingDoctorModal: false,
    openPartOrderHistoryModal: false,
    orderStatus: null,
    orderPaymentStatus: null,
    selectedPartFromLibrary: null,
}

export const orderItemsSlice = createSlice({
    name: 'orderItemsSlice',
    initialState,
    reducers: {
        setSelectedItemsIds: (state, action) => {
            state.selectedItemsIds = action.payload
        },
        addSelectedItem: (state, action) => {
            state.selectedItemsIds.push(action.payload)
        },
        removeSelectedItem: (state, action) => {
            state.selectedItemsIds = state.selectedItemsIds.filter((item) => item !== action.payload)
        },
        clearSelectedItems: (state) => {
            state.selectedItemsIds = []
        },
        setExpandedItemsIds: (state, action) => {
            state.expandedItemsIds = action.payload
        },
        addExpandedItem: (state, action) => {
            state.expandedItemsIds.push(action.payload)
        },
        removeExpandedItem: (state, action) => {
            state.expandedItemsIds = state.expandedItemsIds.filter((item) => item !== action.payload)
        },
        clearExpandedItems: (state) => {
            state.expandedItemsIds = []
        },
        setCollapsedItemsIds: (state, action) => {
            state.collapsedItemsIds = action.payload
        },
        addCollapsedItem: (state, action) => {
            state.collapsedItemsIds.push(action.payload)
        },
        removeCollapsedItem: (state, action) => {
            state.collapsedItemsIds = state.collapsedItemsIds.filter((item) => item !== action.payload)
        },
        clearCollapsedItems: (state) => {
            state.collapsedItemsIds = []
        },
        setFilterOptions: (state, action) => {
            state.filterOptions = action.payload
        },
        setIsCalculatingOrder: (state, action) => {
            state.isCalculatingOrder = action.payload
        },
        setSelectedOrderItemDrawingId: (state, action) => {
            state.selectedOrderItemDrawingId = action.payload
        },
        setOpenDrawingDoctorModal: (state, action) => {
            state.openDrawingDoctorModal = action.payload
        },
        setOpenPartOrderHistoryModal: (state, action) => {
            state.openPartOrderHistoryModal = action.payload
        },
        setSelectedOrderStatus: (state, action) => {
            state.orderStatus = action.payload
        },
        setSelectedOrderPaymentStatus: (state, action) => {
            state.orderPaymentStatus = action.payload
        },
        setSelectedPartFromLibrary: (state, action) => {
            state.selectedPartFromLibrary = action.payload
        },
        setFilteredItemsIds: (state, action) => {
            state.filteredItemsIds = action.payload
        },
        addItemToUpdateQueue: (state, action) => {
            if (!state.updateQueue.includes(action.payload)) {
                state.updateQueue.push(action.payload)
            }
        },
        removeItemFromUpdateQueue: (state, action) => {
            state.updateQueue = state.updateQueue.filter((item) => item !== action.payload)
        },
        clearUpdateQueue: (state) => {
            state.updateQueue = []
        },
    },
})

export const selectSelectedItems = (state) => state.orderItemsSlice.selectedItemsIds
export const selectExpandedItems = (state) => state.orderItemsSlice.expandedItemsIds
export const selectCollapsedItems = (state) => state.orderItemsSlice.collapsedItemsIds
export const selectFilterOptions = (state) => state.orderItemsSlice.filterOptions
export const selectIsCalculatingOrder = (state) => state.orderItemsSlice.isCalculatingOrder
export const selectOrderItemDrawingId = (state) => state.orderItemsSlice.selectedOrderItemDrawingId
export const selectOpenDrawingDoctorModal = (state) => state.orderItemsSlice.openDrawingDoctorModal
export const selectOpenPartOrderHistoryModal = (state) => state.orderItemsSlice.openPartOrderHistoryModal
export const selectedOrderStatus = (state) => state.orderItemsSlice.orderStatus
export const selectOrderPaymentStatus = (state) => state.orderItemsSlice.orderPaymentStatus
export const selectSelectedPartFromLibrary = (state) => state.orderItemsSlice.selectedPartFromLibrary
export const selectFilteredItemsIds = (state) => state.orderItemsSlice.filteredItemsIds
export const selectIsUpdateQueueEmpty = (state) => state.orderItemsSlice.updateQueue.length === 0

export const {
    addCollapsedItem,
    addExpandedItem,
    addItemToUpdateQueue,
    addSelectedItem,
    clearCollapsedItems,
    clearExpandedItems,
    clearSelectedItems,
    clearUpdateQueue,
    removeCollapsedItem,
    removeExpandedItem,
    removeItemFromUpdateQueue,
    removeSelectedItem,
    setCollapsedItemsIds,
    setExpandedItemsIds,
    setFilterOptions,
    setFilteredItemsIds,
    setIsCalculatingOrder,
    setOpenDrawingDoctorModal,
    setOpenPartOrderHistoryModal,
    setSelectedItemsIds,
    setSelectedOrderItemDrawingId,
    setSelectedOrderPaymentStatus,
    setSelectedOrderStatus,
    setSelectedPartFromLibrary,
} = orderItemsSlice.actions

export default orderItemsSlice.reducer
